module.exports = __webpack_public_path__ + "static/media/drummerslogo.719ab855.png";